import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState({
    days: 3,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Set target to 3 days from initial load
    const targetDate = new Date().getTime() + 3 * 24 * 60 * 60 * 1000;
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;
      if (distance < 0) {
        clearInterval(interval);
        return;
      }
      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className="bg-sage text-white py-2 px-4 text-center text-sm font-medium flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4 z-40 relative" data-id="element-265">
      <div className="flex items-center gap-2" data-id="element-266">
        <Clock className="w-4 h-4" data-id="element-267" />
        <span data-id="element-268">OFERTA DE LANZAMIENTO — Solo por 3 días</span>
      </div>
      <div className="flex items-center gap-1 font-bold bg-white/20 px-3 py-1 rounded-full text-xs md:text-sm" data-id="element-269">
        <span data-id="element-270">{String(timeLeft.days).padStart(2, '0')} días</span>
        <span data-id="element-271">:</span>
        <span data-id="element-272">{String(timeLeft.hours).padStart(2, '0')} hrs</span>
        <span data-id="element-273">:</span>
        <span data-id="element-274">{String(timeLeft.minutes).padStart(2, '0')} min</span>
        <span data-id="element-275">:</span>
        <span data-id="element-276">{String(timeLeft.seconds).padStart(2, '0')} seg</span>
      </div>
    </div>;
}